(function () {
  'use strict';

  var gallery   = document.querySelector('[data-section-id]');
  var sectionId = gallery ? gallery.dataset.sectionId : '';
  var gallerySelector = '#pmn-gallery-' + sectionId;

  /* ── Zoom popup ── */
  var popup    = document.querySelector('.js-pmn-zoom-popup');
  var zoomImg  = popup && popup.querySelector('.js-pmn-zoom-img');
  var spinner  = popup && popup.querySelector('.js-pmn-zoom-spinner');
  var closeBtn = popup && popup.querySelector('.js-pmn-zoom-close');
  var backdrop = popup && popup.querySelector('.js-pmn-zoom-backdrop');
  var prevBtn  = popup && popup.querySelector('.js-pmn-zoom-prev');
  var nextBtn  = popup && popup.querySelector('.js-pmn-zoom-next');
  var _idx = 0;

  if (popup && popup.parentNode !== document.body) {
    document.body.appendChild(popup);
  }

  function imgs() {
    return Array.from(
      document.querySelectorAll(gallerySelector + ' .js-product-media-primary-img')
    );
  }

  function updateNav() {
    var list = imgs();
    if (!prevBtn || !nextBtn) return;
    prevBtn.classList.toggle('pmn-hidden', list.length <= 1 || _idx === 0);
    nextBtn.classList.toggle('pmn-hidden', list.length <= 1 || _idx >= list.length - 1);
  }

  function loadImg(src, srcset) {
    if (!zoomImg) return;
    zoomImg.classList.remove('is-loaded');
    if (spinner) spinner.style.display = 'block';
    zoomImg.onload = function () {
      zoomImg.classList.add('is-loaded');
      if (spinner) spinner.style.display = 'none';
    };
    zoomImg.onerror = function () {
      if (spinner) spinner.style.display = 'none';
    };
    if (srcset) { zoomImg.srcset = srcset; } else { zoomImg.removeAttribute('srcset'); }
    zoomImg.src = src;
  }

  function getScrollbarWidth() {
    return window.innerWidth - document.documentElement.clientWidth;
  }

  var _scrollY = 0;

  function openZoom(src, srcset) {
    var list = imgs();
    _idx = list.findIndex(function (i) { return i.src === src; });
    if (_idx < 0) _idx = 0;
    _scrollY = window.scrollY || window.pageYOffset || 0;
    var sbw = getScrollbarWidth();
    document.documentElement.style.setProperty('--pmn-sb-w', sbw + 'px');
    document.body.style.position  = 'fixed';
    document.body.style.top       = '-' + _scrollY + 'px';
    document.body.style.left      = '0';
    document.body.style.right     = '0';
    document.body.style.overflowY = 'scroll';
    document.body.classList.add('pmn-zoom-open');
    popup.classList.add('is-open');
    loadImg(src, srcset);
    updateNav();
  }

  function closeZoom() {
    popup.classList.remove('is-open');
    document.body.classList.remove('pmn-zoom-open');
    document.body.style.position  = '';
    document.body.style.top       = '';
    document.body.style.left      = '';
    document.body.style.right     = '';
    document.body.style.overflowY = '';
    document.documentElement.style.removeProperty('--pmn-sb-w');
    window.scrollTo(0, _scrollY);
    setTimeout(function () {
      if (zoomImg) {
        zoomImg.src = '';
        zoomImg.removeAttribute('srcset');
        zoomImg.classList.remove('is-loaded');
      }
    }, 250);
  }

  function navigate(dir) {
    var list = imgs();
    var ni = _idx + dir;
    if (ni < 0 || ni >= list.length) return;
    _idx = ni;
    loadImg(list[_idx].src, list[_idx].srcset || '');
    updateNav();
    if (window.mtnshop && window.mtnshop.productMedia) {
      window.mtnshop.productMedia.primarySlider.glideInstance.go('=' + _idx);
    }
  }

  /* ── Click en imagen principal → abrir zoom ── */
  var pw = document.querySelector(gallerySelector + ' .js-product-media-primary-wrapper');
  if (pw) {
    pw.addEventListener('click', function (e) {
      var img = e.target.closest('.js-product-media-primary-img');
      if (!img || (img.dataset.mediaType && img.dataset.mediaType !== 'image')) return;
      e.stopPropagation();
      openZoom(img.src, img.srcset || '');
    });
  }

  /* ── Eventos popup ── */
  if (closeBtn) closeBtn.addEventListener('click', closeZoom);
  if (backdrop)  backdrop.addEventListener('click', closeZoom);
  if (prevBtn)   prevBtn.addEventListener('click', function () { navigate(-1); });
  if (nextBtn)   nextBtn.addEventListener('click', function () { navigate(1); });

  document.addEventListener('keydown', function (e) {
    if (!popup || !popup.classList.contains('is-open')) return;
    if (e.key === 'Escape')    closeZoom();
    if (e.key === 'ArrowLeft') navigate(-1);
    if (e.key === 'ArrowRight') navigate(1);
  });

  /* Swipe táctil en popup */
  var _tx = 0;
  if (popup) {
    popup.addEventListener('touchstart', function (e) { _tx = e.touches[0].clientX; }, { passive: true });
    popup.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - _tx;
      if (Math.abs(dx) > 50) navigate(dx < 0 ? 1 : -1);
    });
  }

  /* ── Silenciar zoom original del tema ── */
  var oImg = document.querySelector('.js-product-media-magnify-img');
  var oPop = document.querySelector('.js-product-media-magnify-popup');

  if (oImg) {
    try {
      Object.defineProperty(oImg, 'src', {
        get: function () { return this._s || ''; },
        set: function (v) {
          this._s = v;
          if (v && v.length > 10) openZoom(v, this._ss || '');
        },
        configurable: true
      });
      Object.defineProperty(oImg, 'srcset', {
        get: function () { return this._ss || ''; },
        set: function (v) { this._ss = v; },
        configurable: true
      });
      Object.defineProperty(oImg, 'loading', {
        get: function () { return 'eager'; },
        set: function () {},
        configurable: true
      });
    } catch (e) {}
  }

  if (oPop) {
    try {
      oPop.classList.remove = function () {};
      oPop.style.cssText = 'display:none!important;visibility:hidden!important;pointer-events:none!important;';
    } catch (e) {}
  }

  /* ── FIX: patchTrack ELIMINADO ──────────────────────────────────────
     El patch original sobreescribía scrollLeft/scrollTo del track,
     redirigiendo scroll horizontal→vertical en desktop. Esto funcionaba
     en desktop pero rompía el scroll horizontal de miniaturas en móvil
     porque los getters/setters interferían con activateThumb() en
     snippets-gr-product-media.js.

     El scroll correcto (horizontal en móvil, vertical en desktop) ahora
     lo gestiona directamente scrollToThumb() en snippets-gr-product-media.js
     usando window.innerWidth para decidir la dirección — sin patches.
  ────────────────────────────────────────────────────────────────── */

  /* Mantener gr_product_media_scrollToSlide público para compatibilidad */
  window.gr_product_media_scrollToSlide = function (idx) {
    if (window.mtnshop && window.mtnshop.productMedia) {
      window.mtnshop.productMedia.secondarySlider.scrollToSlide(idx);
    }
  };

})();